import Api, { getSPUDAPIUrl } from '../helpers/api'

export const loadTemplates = async () => {
  const response = await Api.get(`${getSPUDAPIUrl()}notification/email-templates/`)
  return response.data
}
